module.exports = __webpack_public_path__ + "img/组 18-4.736a389c.png";